import { X } from "lucide-react";
import { CONTACT_EMAIL, CONTACT_MAILTO } from "../contact.js";
import { closeDialog } from "../dialog.js";

export const PRIVACY_DIALOG_ID = "privacy-dialog";

/**
 * What actually happens to a submitted enquiry — no "design preview" language left over from the
 * prototype, since GH-894 wired the form to a real endpoint (POST /v1/public/sales-leads).
 */
export function PrivacyDialog() {
  return (
    <dialog
      id={PRIVACY_DIALOG_ID}
      className="info-dialog"
      onClick={(event) => {
        if (event.target === event.currentTarget) closeDialog(PRIVACY_DIALOG_ID);
      }}
    >
      <button
        className="info-dialog__close"
        aria-label="Close information"
        onClick={() => closeDialog(PRIVACY_DIALOG_ID)}
      >
        <X />
      </button>
      <p className="overline">Your information</p>
      <h2>A simple enquiry.</h2>
      <p>
        What you enter here — your name, email, organization, and anything else you tell us — goes
        to GiveHere's sales team so we can follow up about a demo or keep you informed, and nowhere
        else.
      </p>
      <p>
        We don't sell or share it with any third party. If you'd rather not use this form, email us
        directly at <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>.
      </p>
      <button className="btn btn--primary" onClick={() => closeDialog(PRIVACY_DIALOG_ID)}>
        Got it
      </button>
    </dialog>
  );
}
